<script>
    export let columns;
    export let classes = '';
</script>

<div class="{` ${columns ? `col-md-${columns}` : ''} ${classes}`}">
    <slot></slot>
</div>
